<template>
<div>
  <vs-row>
    <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
            <h5>
      <i class="dot"></i> 기본정보
      </h5>
    </vs-col>
  </vs-row>
  <div class="grid grid-cols-12 gap-x-6 gap-y-4 ">
    <div class="col-span-6 flex items-center">
      <div class="label-text mr-4">회사명</div>
      <span v-if="isPrint"> {{form.inputA_1}} </span>
      <field-selector v-else class="w-full flex-1" v-model="form.inputA_1" :field-name="form.inputA_1_name" :readonly="board.readonly" @select="onSelectFieldSelector"/>
    </div>
  </div>
  <div class="grid grid-cols-12 gap-x-6 gap-y-4 ">
    <div class="col-span-6 flex items-center">
      <div class="label-text mr-4">사업명</div>
      <span v-if="isPrint"> {{form.inputA_2}} </span>
      <ml-input v-else class="w-full flex-1" v-model="form.inputA_2" :readonly="board.readonly"/>
    </div>
  </div>
  <div class="grid grid-cols-12 gap-x-6 gap-y-4 ">
    <div class="col-span-12 flex items-center">
      <div class="label-text mr-4">점검구분</div>
      <span v-if="isPrint"> {{
            optionCheckBox.filter(x => x.id == form.category)[0].label
      }} </span>
      <div class="ml-group-checkBox flex flex-wrap w-full flex-1" v-else>
        <vs-checkbox
          v-for="checkbox in optionCheckBox"
          v-model="form.category"
          :vs-value="checkbox.id"
          @change="onCheck($event)"
          class="mr-8 mb-2"
          :readonly="board.readonly"
        >
          {{ checkbox.label }}
        </vs-checkbox>
      </div>
    </div>
  </div>
  <div class="grid grid-cols-12 gap-x-6 gap-y-4 ">
    <div class="col-span-4 flex items-center">
      <div class="label-text mr-4">점검일자</div>
      <span v-if="isPrint"> {{form.inputA_3}} </span>
      <date-selector v-else class="w-full flex-1" v-model="form.inputA_3" :readonly="board.readonly"/>
    </div>
  </div>
  <div class="grid grid-cols-12 gap-x-6 gap-y-4 ">
    <div class="col-start-1 col-span-4 flex items-center">
      <div class="label-text mr-4">소속</div>
      <span v-if="isPrint"> {{form.inputA_11}} </span>
      <ml-input v-else class="w-full flex-1" v-model="form.inputA_11" :readonly="true"/>
    </div>
  </div>
  <div class="grid grid-cols-12 gap-x-6 gap-y-4 ">
    <div class="col-span-4 flex items-center">
      <div class="label-text mr-4">부서</div>
      <span v-if="isPrint"> {{form.inputA_4}} </span>
      <ml-input v-else class="w-full flex-1" v-model="form.inputA_4" :readonly="true"/>
    </div>
  </div>
  <div class="grid grid-cols-12 gap-x-6 gap-y-4 ">
    <div class="col-span-4 flex items-center">
      <div class="label-text mr-4">점검부서</div>
      <span v-if="isPrint"> {{form.inputA_5}} </span>
      <ml-input v-else class="w-full flex-1" v-model="form.inputA_5" :readonly="board.readonly"/>
    </div>
    <div class="col-span-4 flex items-center">
      <div class="label-text mr-4">직위</div>
      <span v-if="isPrint"> {{form.inputA_6}} </span>
      <ml-input v-else class="w-full flex-1" v-model="form.inputA_6" :readonly="board.readonly"/>
    </div>
    <div class="col-span-4 flex items-center">
      <div class="label-text mr-4">점검자</div>
      <span v-if="isPrint"> {{form.inputA_7}} </span>
      <ml-input v-else class="w-full flex-1" v-model="form.inputA_7" :readonly="board.readonly"/>
    </div>
  </div>
  <div class="grid grid-cols-12 gap-x-6 gap-y-4 ">
    <div class="col-span-4 flex items-center">
      <div class="label-text mr-4">수검부서</div>
      <span v-if="isPrint"> {{form.inputA_8}} </span>
      <ml-input v-else class="w-full flex-1" v-model="form.inputA_8" :readonly="board.readonly"/>
    </div>
    <div class="col-span-4 flex items-center">
      <div class="label-text mr-4">직위</div>
      <span v-if="isPrint"> {{form.inputA_9}} </span>
      <ml-input v-else class="w-full flex-1" v-model="form.inputA_9" :readonly="board.readonly"/>
    </div>
    <div class="col-span-4 flex items-center">
      <div class="label-text mr-4">수검자</div>
      <span v-if="isPrint"> {{form.inputA_10}} </span>
        <ml-input v-else class="w-full flex-1" v-model="form.inputA_10" :readonly="board.readonly"/>
    </div>
  </div>
  <vs-row style="padding-top: 1rem;" v-if="image.length > 0">
    <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-w="12">
      <i class="dot"></i> 참고이미지
    </vs-col>
  </vs-row>
  <vs-row>
    <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-w="10">
      <img :src="image" width="100%" :readonly="board.readonly"/>
    </vs-col>
  </vs-row>

  <table-safeguard
  :dataRequest="dataTable"
  :list="form.list"
  :isPrint="isPrint"
  :isReadonly="board.readonly"
  @update-list-check="updateListCheck"></table-safeguard>
  <vs-row style="padding: 1rem 0rem;">
    <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
      <i class="dot"></i> 기타 특이사항 및  요구사항
    </vs-col>
  </vs-row>
  <div class="col-span-12 flex items-start">
    <div class="label-text mr-4 mt-2">종합의견/특이사항</div>
    <span v-if="isPrint"> {{form.inputB_1}} </span>
    <ml-textarea v-else class="flex-1 w-full" rows="5" v-model="form.inputB_1" :readonly="board.readonly"/>
  </div>
  <div class="col-span-12 flex items-start">
    <div class="label-text mr-4 mt-2">개선요구사항</div>
    <span v-if="isPrint"> {{form.inputB_2}} </span>
    <ml-textarea v-else class="flex-1 w-full" rows="5" v-model="form.inputB_2" :readonly="board.readonly"/>
  </div>
  <file-upload-module class="w-full" v-if="!isPrint" v-model="form.fileList" :readonly="board.readonly"/>
</div>
</template>

<script>
  import DateSelector from '@/components/selector/DateSelector'
  import imgA from '../../../../assets/images/_fira/fira-image-a.png'
  import imgB from '../../../../assets/images/_fira/fira-image-b.png'
  import imgC from '../../../../assets/images/_fira/fira-image-c.png'
  import imgD from '../../../../assets/images/_fira/fira-image-d.png'
  import imgE from '../../../../assets/images/_fira/fira-image-e.png'
  import TableSafeguard from '@/components/TableSafeguard.vue'
  import FileUploadModule from '@/views/modules/FileUploadModule'
  import FieldSelector from "@/components/selector/FieldSelector.vue";
export default {
  name: 'Write',
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    board: {
      immediate: true,
      deep: true,
      handler(value) {
        this.form.inputA_1 = this.value && this.value.inputA_1 ? this.value.inputA_1 : this.board.projectTitle
        this.form.inputA_4 = this.value && this.value.inputA_4 ? this.value.inputA_4 : this.board.writer.section
        this.form.inputA_11 = this.value && this.value.inputA_11 ? this.value.inputA_11 : this.board.writer.department
      }
    },
    value(value) {
      const keys = Object.keys(this.form)
      for (const key of keys) {
        this.form[key] = value[key]
      }

      // Load table and image
      let objCheckBoxSelected = this.optionCheckBox.find((n) => n.label ===  this.form.categoryLabel);
      if(objCheckBoxSelected) {
        this.image = objCheckBoxSelected.img;
        this.dataTable = objCheckBoxSelected.dataTable;
      }
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = value.inputA_1_name;
        value.summary = {
          "점검표": [{'중량물·운반기계 안전점검표': 1}],
          "점검구분": [
            { [this.form.categoryLabel]: 1 }
          ]
        }
        this.$emit("input", value);
      }
    }
  },
  computed: {
    optionCheckBox () {
      const list = [
          {
            id: '바지선',
            label: '바지선',
            img: imgA,
            dataTable: [
              {
                title: "운항 적정여부",
                data: [
                  {
                    text: "바지선 운항 등록 여부",

                    index: 1
                  }
                ]
              },
              {
                title: "목적 외 사용금지",
                data: [
                  {
                    text: "작업 외 사용금지 여부",
                    index: 2
                  }
                ]
              },
              {
                title: "안전 운항을 위한 준수사항",
                data: [
                  {
                    text: "적재물에 대한 운반선 선정의 적정성 여부",
                    index: 3
                  },
                  {
                    text: "적재물의 과적 여부",
                    index: 4
                  },
                  {
                    text: "파랑으로 인한 선체의 요동으로 적재물의 전도, 탈락 등 예방조치 여부",
                    index: 5
                  },
                  {
                    text: "운반거리, 해상조건 및 적재물의 크기 또는 무게에 대한 예선과 부선의 용량 적정 여부",
                    index: 6
                  },
                  {
                    text: "예선의 로프 이상 여부 및 부선과의 연결 방법 확인",
                    index: 7
                  },
                  {
                    text: "음주상태이거나 정상적인 건상상태를 유지하지 못한 작업자의 승선 금지 여부",
                    index: 8
                  }
                ]
              },
              {
                title: "안전장치 설치 및 사용상태",
                data: [
                  {
                    text: "현문은 조석간만의 차에 의한 동요에 견딜 수 있도록 조정 여부",
                    index: 9
                  },
                  {
                    text: "추락 방지를 위한 안전난간대 설치 여부",
                    index: 10
                  },
                  {
                    text: "앵커, 와이어로프, 체인 또는 섬유로프의 손상 및 결함 여부",
                    index: 11
                  },
                  {
                    text: "윈치 작동상태 여부",
                    index: 12
                  },
                  {
                    text: "윈드라스 작동상태 여부",
                    index: 13
                  },
                  {
                    text: "스토퍼 작동상태 여부",
                    index: 14
                  },
                  {
                    text: "소화기 구비·관리상태 여부",
                    index: 15
                  },
                  {
                    text: "구명장비 구비·관리상태 여부",
                    index: 16
                  }
                ]
              },
              {
                title: "안전작업을 위한 준수사항",
                data: [
                  {
                    text: "적재, 적하 시 책임자의 현장관리 감독 여부(작업지휘자 유무 확인)",
                    index: 17
                  },
                  {
                    text: "작업자의 안전모, 안전화, 구명장비 등 안전장구 및 복장 착용 여부",
                    index: 18
                  }
                ]
              }
            ]
          },
          {
            id: '이동식크레인',
            label: '이동식크레인',
            img: imgB,
            dataTable: [
              {
                title: "운전자격 적정여부",
                data: [
                  {
                    text: "운전원 면허 자격 여부\n  ·기중기 : 건설기계조종사면허\n  ·차량탑재형 이동식크레인 : 1종 보통(적재중량 12톤 미만), 1종 대형(적재중량 12톤 이상)",
                    index: 1
                  }
                ]
              },
              {
                title: "목적 외 사용금지",
                data: [
                  {
                    text: "불법 탑승시설 부착 사용 여부",
                    index: 2
                  }
                ]
              },
              {
                title: "화물 양중작업의 안전성",
                data: [
                  {
                    text: "유압발생장치(유압펌프의 이상음, 발열, 누설 여부 확인 및 작동유 탱크의 유량 및 오일 누설여부 확인)",
                    index: 3
                  },
                  {
                    text: "조작장치(조작밸브, 레버의 작동, 오일 누설여부 확인 및 상·하부 조작부 작동상태, 스위치 등 동작상태 확인)",
                    index: 4
                  },
                  {
                    text: "전도 임계하중* 초과 사용 여부(전도 발생 직전 크레인 붐 끝단에서 양중 할 수 있는 최대하중)",
                    index: 5
                  },
                  {
                    text: "실린더 및 카운터밸런스 밸브 오일 누설 및 자연하강 여부",
                    index: 6
                  },
                  {
                    text: "붐의 균열, 변형, 손상 및 작동상태 여부",
                    index: 7
                  }
                ]
              },
              {
                title: "안전장치 설치 및 사용상태",
                data: [
                  {
                    text: "아우트리거(외관의 균열, 변형, 손상여부, 작동상태 및 유압라인 오일 누설여부 확인)",
                    index: 8
                  },
                  {
                    text: "훅 해지장치(설치 및 외관의 균열, 변형, 손상여부 및 회전상태 확인)",
                    index: 9
                  },
                  {
                    text: "과부하방지장치 작동상태 확인 여부",

                    index: 10
                  },
                  {
                    text: "권과방지장치 작동상태 확인 여부",

                    index: 11
                  },
                  {
                    text: "비상정지장치 작동상태 확인 여부",

                    index: 12
                  }
                ]
              },
              {
                title: "안전작업을 위한 준수사항",
                data: [
                  {
                    text: "유도자 및 신호수 배치(작업지휘자 유무 확인)",

                    index: 13
                  },
                  {
                    text: "줄걸이 작업안전(와이어로프 변형, 마모, 파손, 체결상태, 이탈방지핀 등 확인)",

                    index: 14
                  }
                ]
              },
            ]
          },
          {
            id: '굴착기',
            label: '굴착기',
            img: imgC,
            dataTable: [
              {
                title: "운전자격 적정여부",
                data: [
                  {
                    text: "운전원 면허 자격 여부\n ·3톤 이상 : 건설기계조종사면허, 3톤 미만 : 소형건설기계조종교육 이수",

                    index: 1
                  }
                ]
              },
              {
                title: "목적 외 사용금지",
                data: [
                  {
                    text: "작업 외 사용금지 여부",

                    index: 2
                  }
                ]
              },
              {
                title: "운행의 안전성",
                data: [
                  {
                    text: "운전자의 시야 확보 여부(전면 유리상태 및 후사경 설치상태)",

                    index: 3
                  },
                  {
                    text: "작업장 내 운행로와 보행로의 분리상태 여부",

                    index: 4
                  }
                ]
              },
              {
                title: "안전운행을 위한 준수사항",
                data: [
                  {
                    text: "작업반경 내 출입통제 여부(근로자, 신호수·유도자 및 장비·차량 등 위치확인)",

                    index: 5
                  },
                  {
                    text: "상·하 동시 작업 금지 여부(유도자 및 신호수 배치 유무 확인)",

                    index: 6
                  },
                  {
                    text: "버킷에 근로자 탑승금지 여부",

                    index: 7
                  },
                  {
                    text: "운전원 운전석 이탈 시 버킷 지상 내려놓기 여부",

                    index: 8
                  }
                ]
              },
              {
                title: "안전장치 설치 및 사용상태",
                data: [
                  {
                    text: "안전레버 작동상태(레버를 내리면 모든 작동이 중단) 여부",

                    index: 9
                  },
                  {
                    text: "버킷 유압커플러 이탈방지장치(안전핀) 체결상태 여부",

                    index: 10
                  },
                  {
                    text: "카운트 웨이트 추가 금지 준수 및 고정상태 여부",

                    index: 11
                  },
                  {
                    text: "소화기 구비·관리상태 여부",

                    index: 12
                  }
                ]
              },
              {
                title: "안전장치 설치 및 사용상태",
                data: [
                  {
                    text: "붐(암), 유압장치, 선회장치 등 주요구조부 상태 여부",

                    index: 13
                  },
                  {
                    text: "타이어 손상 및 마모상태 여부",

                    index: 14
                  },
                  {
                    text: "운전석 조작장치 및 제동장치 등 작동상태 여부",

                    index: 15
                  },{
                    text: "버킷 규격 및 연결핀 설치상태 여부",

                    index: 16
                  },
                  {
                    text: "전조·후미·경광등 및 혼(Horn) 작동상태 여부",

                    index: 17
                  }
                ]
              },
            ]
          },
          {
            id: '트럭류',
            label: '트럭류',
            img: imgD,
            dataTable: [
              {
                title: "운전자격 적정여부",
                data: [
                  {
                    text: "운전원 면허 자격 여부\n·덤프트럭 : 1종 대형면허, 건설기계조종사면허\n·화물자동차 : 1종 보통면허(적재중량 12톤 미만), 1종 대형면허(적재중량 12톤 이상)",
                    index: 1
                  }
                ]
              },
              {
                title: "운행의 안전성",
                data: [
                  {
                    text: "운전자의 시야 확보 여부(전면 유리상태 및 후사경 설치상태)",
                    index: 2
                  },
                  {
                    text: "작업장 내 운행로와 보행로의 분리상태 여부",
                    index: 3
                  }
                ]
              },
              {
                title: "안전운행을 위한 준수사항",
                data: [
                  {
                    text: "주·정차 시 브레이크 체결 여부(경사면인 경우 고임목 설치)",
                    index: 4
                  },
                  {
                    text: "적재함 근로자 탑승금지 및 과적금지 여부",
                    index: 5
                  },
                  {
                    text: "적재함 올린상태 운행금지 여부",
                    index: 6
                  },
                  {
                    text: "현장 내 제한속도 표시 및 준수 여부",
                    index: 7
                  },
                  {
                    text: "운전자가 잘 볼 수 있는 위치 유도자(신호수) 유도 여부(신호수복장 착용, 차량 유도봉·경광 등의 보조도구 사용)",
                    index: 8
                  },
                  {
                    text: "안전벨트 설치 및 착용상태 여부",
                    index: 9
                  }
                ]
              },
              {
                title: "안전장치 설치 및 사용상태",
                data: [
                  {
                    text: "후진경보장치 및 후방카메라 작동상태 여부",

                    index: 10
                  },
                  {
                    text: "적재함 불시 하강방지용 안전블록 설치상태 여부",

                    index: 11
                  },
                  {
                    text: "전조등과 후미등 점등상태 및 혼(Horn) 작동상태 여부",

                    index: 12
                  },
                  {
                    text: "소화기 및 고임대(2개 이상) 구비·관리상태 여부",

                    index: 13
                  }
                ]
              },
              {
                title: "화물적재 및 운행의 안전성",
                data: [
                  {
                    text: "유압장치, 조작장치 등 주요구조부 상태 여부",

                    index: 14
                  },
                  {
                    text: "주·정차 시 제동장치 작동 및 시동키 분리 여부",

                    index: 15
                  },
                  {
                    text: "타이어 손상 및 마모상태 여부",

                    index: 16
                  },
                  {
                    text: "적재함 덮개 설치 및 사용상태 여부",

                    index: 17
                  },
                  {
                    text: "적재함 상승 및 하강 시 경고음 작동상태 여부",

                    index: 18
                  }
                ]
              },
            ]
          },
          {
              id: '지게차',
              label: '지게차',
              img: imgE,
              dataTable: [
                {
                  title: "운전자격 적정여부",
                  data: [
                    {
                      text: "운전원 면허 자격 여부\n  ·3톤 이상 : 건설기계조종사면허\n  ·3톤 미만 : 소형건설기계조종교육 이수",
                      index: 1
                    }
                  ]
                },
                {
                  title: "목적 외 사용금지",
                  data: [
                    {
                      text: "작업 외 사용금지 여부",
                      index: 2
                    }
                  ]
                },
                {
                  title: "운행의 안전성",
                  data: [
                    {
                      text: "운전자의 시야 확보 여부(화물 과다적재, 포크 과다상승 상태 운행금지)",


                      index: 3
                    },
                    {
                      text: "포크에 화물을 매단 상태로 운행(급선회）여부",


                      index: 4
                    },
                    {
                      text: "전용통로 확보 및 작업지휘자를 통한 작업자 출입제한 여부(지게차 운행 통로에 근로자 출입통제)",


                      index: 5
                    },
                    {
                      text: "사업장 내 제한속도 지정 및 준수 여부",


                      index: 6
                    },
                    {
                      text: "승차석 외에 근로자 탑승운행금지 준수 여부",


                      index: 7
                    },
                    {
                      text: "유압장치(모터, 실린더, 배관 등）누설, 손상 및 마모 여부",


                      index: 8
                    },
                    {
                      text: "타이어 손상 및 마모 여부",


                      index: 9
                    }
                  ]
                },
                {
                  title: "화물적재의 안전성",
                  data: [
                    {
                      text: "화물 과다적재 및 편하중 적재 여부",
                      index: 10
                    }
                  ]
                },
                {
                  title: "안전장치 설치 및 사용상태",
                  data: [
                    {
                      text: "좌석안전띠 설치 및 착용상태 여부",
                      index: 11
                    },
                    {
                      text: "전조등 및 후미등 점등상태 여부",
                      index: 12
                    },
                    {
                      text: "헤드가드 및 백레스트 설치상태 여부",
                      index: 13
                    },
                    {
                      text: "후방 확인장치 설치상태 여부(후사경, 룸밀러, 후방경보장치, 후방카메라 등)",
                      index: 14
                    },
                    {
                      text: "운행 경로상의 사각지대 반사경 설치상태 여부",
                      index: 15
                    },
                    {
                      text: "운전석 조작장치 및 제동장치 등 작동상태 여부",
                      index: 16
                    },
                    {
                      text: "포크 고정핀 설치·사용상태 여부",
                      index: 17
                    },
                    {
                      text: "카운트 웨이트 추가 금지 준수 및 고정상태 여부",
                      index: 18
                    },
                    {
                      text: "경사지 주차금지 준수 여부 ",
                      index: 19
                    }
                  ]
                },
              ]
            }
          ];
      return list
    }
  },
  data () {
    return {
      form: {
        list: [
        ],
        category: [],
        categoryLabel: '',
        inputA_1:'',
        inputA_1_name:'',
        inputA_2: '',
        inputA_3: '',
        inputA_4: '',
        inputA_5: '',
        inputA_6: '',
        inputA_7: '',
        inputA_8: '',
        inputA_9: '',
        inputA_10: '',
        inputA_11: '',
        inputB_1: '',
        inputB_2: '',
        fileList: []
      },
      image: '',
      dataTable: [
      ],
    }
  },
  methods: {
    onSelectFieldSelector (field) {
      this.form.inputA_1_name = field.field_name
    },
    updateListCheck(indexRows, text) {
      this.form.list[indexRows].is_checked = text
    },
    onCheck (value) {
      this.form.category = [value[value.length - 1]]
      this.form.categoryLabel = this.optionCheckBox.filter(x => x.id == this.form.category)[0].label
      if(this.form.category[0]) {
        this.image = this.optionCheckBox.filter(x => x.id == this.form.category[0])[0].img
        this.dataTable = this.optionCheckBox.filter(x => x.id == this.form.category[0])[0].dataTable
        let temp = []
        this.dataTable.forEach(element => {
          element.data.forEach(el => {
            temp.push(
              {
                text: el.text,
                is_checked: "",
                note: el.note
              }
            )
          })
        });
        this.form.list = temp
      }
      else {
        this.image = ''
        this.dataTable = {
          rows: []
        }
        this.dataTable = []
      }
    }
  },
  components: {
    FieldSelector,
    DateSelector,
    TableSafeguard,
    FileUploadModule
  },
}
</script>

<style scoped>
  .titleHeader {
    width: 100%;
    text-align: center;
  }
  .headerTable {
    padding: 1rem;
    background-color:#F9F9F9;
    border: 1px solid #CDCDCD;
  }
  .label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
  margin-right: 16px;
  }
  .mt-component-form {
    margin-top: 20px;
  }
  .grid {
    padding-top: 1rem;
  }
</style>
